import React from 'react';
import { Modal, Table, Form, Empty, Input, Button, Tag } from 'antd';
import { APROBADO, REGISTRADO, ANULADO, RECHAZADO } from '../../../common/types/ordenCompraEstadoType';
import "./styles.css";

import global from '../../../common/utility/global';

const { Search } = Input;

class ImportarModalOC extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    renderColor = (row) => {
        if (row.idOrdenCompraEstado || row.idOrdenServicioEstado === REGISTRADO)
            return 'blue';
        if (row.idOrdenCompraEstado || row.idOrdenServicioEstado === APROBADO)
            return 'green';
        if (row.idOrdenCompraEstado || row.idOrdenServicioEstado === RECHAZADO)
            return 'orange';
        if (row.idOrdenCompraEstado || row.idOrdenServicioEstado === ANULADO)
            return 'red';
    };


    handleSearch = (value) => {
        const dataSource = this.props.formValues.dataSource.filter(item => {
            return global
                .formatSearch(`${item.fechaStr} - ${item.nombreTipoComprobante} - ${item.serie}-${item.documento} - ${item.totalStr}`)
                .match(global.formatSearch(value));
        });
        this.props.form.setFieldsValue({ dataSource });
    };

    handleSerieNumero = (value) => {
        return value.serie + "-" + value.documento;
    };

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        getFieldDecorator('dataSource', { initialValue: this.props.formValues.dataSource });
        getFieldDecorator('loading', { initialValue: false });
        return (
            <Modal
                title={this.props.tittle}
                visible={this.props.visible}
                style={{ top: 30 }}
                width="800px"
                onCancel={() => {
                    this.props.form.resetFields();
                    this.props.onClose()
                }}
                footer={[
                    <Button
                        key="send"
                        type="primary"
                        onClick={() => {
                            this.props.form.resetFields();
                            this.props.onClose()
                        }}
                    >
                        Ok
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="">
                                {getFieldDecorator('inputSearch', {
                                    initialValue: ''
                                })(
                                    <Search
                                        placeholder="Buscar..."
                                        autoComplete="off"
                                        maxLength={100}
                                        loading={getFieldValue('loading')}
                                        onSearch={value => this.handleSearch(value)}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Table
                                size="small"
                                style={{ overflowX: 'auto' }}
                                rowKey={record => this.handleSerieNumero(record)}
                                dataSource={getFieldValue('dataSource')}
                                rowClassName='cursor-pointer'
                                className={'tablecotizacion'}

                                //onRow={(item) => ({ onClick: () => (this.props.onSelect(item)) })}
                                rowSelection={{
                                    onChange: this.props.onSelect,
                                    selectedRowKeys: this.props.formValues.selectedRowKeys,
                                    hideDefaultSelections: false,
                                    /*         getCheckboxProps: record => ({
                                                disabled: record.razonSocialCliente === 'BI GRAND CONFECCIONES S.A.C.', // Column configuration not to be checked
                                                razonSocialCliente: record.razonSocialCliente,
                                              }), */
                                }}
                                locale={{
                                    emptyText: <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="No se encontraron datos."
                                    />
                                }}
                                columns={[

                                    {
                                        title: 'Fecha',
                                        dataIndex: 'fechaStr',
                                        key: 'fechaStr',
                                        sorter: true
                                    },
                                    {
                                        title: 'Proveedor',
                                        dataIndex: 'razonSocial',
                                        key: 'razonSocial',
                                        sorter: true,
                                        render: (value) => (
                                            <div style={{ minWidth: "150px" }}>{value}</div>
                                        )
                                    },
                                    {
                                        title: 'Tipo Documento Proveedor',
                                        dataIndex: 'tipoDocumentoProveedor',
                                        key: 'tipoDocumentoProveedor',
                                        sorter: true
                                    },
                                    {
                                        title: 'Serie / Documento',
                                        dataIndex: 'serie',
                                        key: 'serie',
                                        render: (data, row) => (
                                            <span>{row.serie}-{row.documento}</span>
                                        )
                                    },
                                    {
                                        title: 'Total',
                                        dataIndex: 'total',
                                        key: 'total',
                                        align: 'right',
                                        render: (data) => (
                                            <span>{data.toFixed(2)}</span>
                                        )
                                    }



                                ]}
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(ImportarModalOC)